import React, { PropsWithChildren } from "react";
import { Button, Card, Flex, Row, Typography } from "@app/ui";

type Action = {
    label: string;
    isDisabled?: boolean;
    icon?: string;
    method: () => void;
};

interface CardWithActionsProps extends PropsWithChildren {
    title?: string;
    icon?: string;
    actions?: {
        onConfirm?: Action;
        onCancel?: Action;
    };
};

export const CardWithActions = ({ title, icon, children, actions = {} }: CardWithActionsProps) => {
    const { onCancel, onConfirm } = actions;
    return (
        <Card type="inner" title={
            <Flex>
                {icon ? (
                    <i className={icon} style={{
                        width: 16,
                        height: 16,
                        fontSize: 16,
                        marginRight: 14
                    }} />
                ) : null}
                {title ? (
                    <Typography.Title style={{
                        fontWeight: 600,
                        fontSize: 16,
                        margin: 0
                    }}>
                        {title}
                    </Typography.Title>

                ) : null}
            </Flex>
        }>
            {children}

            {onConfirm !== undefined || onCancel !== undefined ? [
                <div key="divider" className="-mvc-divider" />,
                <Row key="buttons">
                    <Flex style={{ width: '100%' }} gap="small" justify="flex-end" align="flex-end">
                        <Button
                            type="primary"
                            color="default"
                            variant="solid"
                            icon={<i className={onCancel.icon || "fa-regular fa-x -m-r-1"} />}
                            onClick={onCancel.method}
                            disabled={onCancel.isDisabled}
                        >
                            {onCancel.label}
                        </Button>
                        <Button
                            type="primary"
                            color="primary"
                            variant="solid"
                            icon={
                                <i className={onConfirm.icon || "fa-light fa-floppy-disk -m-r-1"} />
                            }
                            onClick={onConfirm.method}
                            disabled={onConfirm.isDisabled}
                        >
                            {onConfirm.label}
                        </Button>
                    </Flex>
                </Row>
            ] : null}

        </Card>
    );
};